const NewsSection = () => {
  const newsItems = [
    {
      id: 1,
      date: '2026.01.15',
      category: 'お知らせ',
      categoryColor: 'bg-primary-light',
      title: '新規利用者様の見学会を開催します',
    },
    {
      id: 2,
      date: '2026.01.10',
      category: 'イベント',
      categoryColor: 'bg-blue-200',
      title: '就職活動セミナーを実施しました',
    },
    {
      id: 3,
      date: '2026.01.05',
      category: '実績',
      categoryColor: 'bg-yellow-200',
      title: '利用者様3名が一般企業への就職に成功しました',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Left: Section Title */}
          <div className="lg:col-span-1">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-text-dark sticky top-32">
              お知らせ
            </h2>
          </div>

          {/* Right: News List */}
          <div className="lg:col-span-3 space-y-6">
            {newsItems.map((news, index) => (
              <div key={news.id}>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-4">
                  <span className="text-text-medium text-sm whitespace-nowrap">{news.date}</span>
                  <span
                    className={`${news.categoryColor} text-text-dark text-xs px-3 py-1 rounded-full inline-block w-fit whitespace-nowrap`}
                  >
                    {news.category}
                  </span>
                  <h3 className="text-text-dark text-base sm:text-lg font-medium flex-1">
                    {news.title}
                  </h3>
                </div>
                {index < newsItems.length - 1 && (
                  <div className="border-b border-gray-200"></div>
                )}
              </div>
            ))}

            {/* View All Link */}
            <div className="pt-6 text-right">
              <button className="inline-flex items-center text-primary font-medium hover:text-primary/70 transition-colors group cursor-pointer">
                お知らせ一覧へ
                <i className="ri-arrow-right-line ml-2 text-lg group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
